import { render, staticRenderFns } from "./employees-by-organization-size.vue?vue&type=template&id=39554a12&scoped=true&"
import script from "./employees-by-organization-size.vue?vue&type=script&lang=js&"
export * from "./employees-by-organization-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39554a12",
  null
  
)

export default component.exports